"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ERROR_ID = void 0;
exports.mapStateToProps = mapStateToProps;
var _reactRedux = require("react-redux");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _nuiLogger = _interopRequireDefault(require("@concur/nui-logger"));
var _client = _interopRequireDefault(require("@concur/nui-config/lib/client"));
var _selectors = require("../../redux/selectors");
var _crossPlatformDelivery = require("../../util/crossPlatformDelivery");
var _config = _interopRequireDefault(require("../../config"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var ERROR_ID = exports.ERROR_ID = 'app-error-container';
function mapStateToProps(state) {
  return {
    brandingId: (0, _selectors.getBrandingId)(state),
    homeUrl: (0, _selectors.getHomeUrl)(state),
    lang: (0, _selectors.getLang)(state),
    langMode: (0, _selectors.getLangMode)(state),
    theme: (0, _selectors.getTheme)(state)
  };
}
var ErrorBase = function ErrorBase(props) {
  var backUrl = props.backUrl,
    brandingId = props.brandingId,
    className = props.className,
    correlationId = props.correlationId,
    customDescription = props.customDescription,
    customHeader = props.customHeader,
    homeUrl = props.homeUrl,
    lang = props.lang,
    langMode = props.langMode,
    links = props.links,
    paragraphs = props.paragraphs,
    theme = props.theme,
    type = props.type;
  var clientConfig = (0, _client.default)();
  var config = Object.keys(clientConfig).length > 0 ? clientConfig : _config.default;
  var dataCenterLocation = (0, _crossPlatformDelivery.parseDataCenterFromXpdManifestName)(config);
  var errorProps = {
    backUrl: backUrl,
    brandingId: brandingId,
    className: className,
    correlationId: correlationId,
    customDescription: customDescription,
    customHeader: customHeader,
    homeUrl: homeUrl,
    lang: langMode || lang || 'en',
    links: links,
    paragraphs: paragraphs,
    themeName: theme,
    type: type,
    dataCenterLocation: dataCenterLocation
  };
  (0, _react.useEffect)(function () {
    if (window.cnqr && window.cnqr.coreui && window.cnqr.coreui.AppError) {
      window.cnqr.coreui.errorProps = errorProps;
      window.cnqr.coreui.AppError.render(errorProps, ERROR_ID);
    } else {
      _nuiLogger.default.error({
        category: 'nui-shell',
        message: '[AppError] The ui-floorplans script is not loaded'
      });
    }
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    id: ERROR_ID
  });
};
ErrorBase.propTypes = {
  customHeader: _propTypes.default.string,
  backUrl: _propTypes.default.string,
  className: _propTypes.default.string,
  correlationId: _propTypes.default.string,
  customDescription: _propTypes.default.string,
  lang: _propTypes.default.string,
  links: _propTypes.default.arrayOf(_propTypes.default.shape({
    url: _propTypes.default.string.isRequired,
    text: _propTypes.default.string.isRequired
  })),
  paragraphs: _propTypes.default.arrayOf(_propTypes.default.shape({
    className: _propTypes.default.string,
    text: _propTypes.default.string
  })),
  type: _propTypes.default.string
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps)(ErrorBase);